// src/store/chartSlice.js

import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  charts: [], // Stores image data for all charts
  isExportingPDF: false,
  isExportingPPT: false,
};

const chartSlice = createSlice({
  name: 'charts',
  initialState,
  reducers: {
    setCharts(state, action) {
      state.charts = action.payload;
    },
    setExportingPDF(state, action) {
      state.isExportingPDF = action.payload;
    },
    setExportingPPT(state, action) {
      state.isExportingPPT = action.payload;
    },
  },
});

export const { setCharts, setExportingPDF, setExportingPPT } = chartSlice.actions;

export default chartSlice.reducer;
